// Pure helpers for the Dashboard. Kept in their own module so:
//   1. Vite Fast Refresh works on Dashboard.jsx (only-component-exports rule).
//   2. The Vitest suite can import them without rendering the Dashboard.

// "h ago / min ago / s ago" relative-time formatter for the subtitle
// and Live Activity panel.
export function fmtSinceForDashboard(iso, nowMs = Date.now()) {
  if (!iso) return '';
  const ms = nowMs - new Date(iso).getTime();
  if (ms < 0) return '';
  const s = Math.floor(ms / 1000);
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} min ago`;
  return `${Math.floor(m / 60)}h ago`;
}

// Build the dashboard subtitle from the snapshot's `subtitle` block.
// Pure, testable, deterministic given a fixed `nowMs`.
export function formatDashboardSubtitle(sub, nowMs = Date.now()) {
  if (!sub) return 'Live status · loading…';
  const parts = ['Live status'];
  if (sub.last_delivery_at) {
    parts.push(`last delivery ${fmtSinceForDashboard(sub.last_delivery_at, nowMs)}`);
  } else {
    parts.push('no deliveries yet');
  }
  if (sub.failed_today && sub.failed_today > 0) {
    parts.push(`${sub.failed_today} failed today`);
  }
  return parts.join(' · ');
}
